import React, {Component} from 'react';

import TextInput from "../../../../component/input/TextInput";

import * as stringUtil from "../../../../util/stringUtil";
import * as apiUtil from '../../../../util/apiUtil';
import Modal from "../../../../component/modal/ModalTemplate";
import Loading from "../../../../component/loading/Loading";

class MessageTestModal extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.setValue = this.setValue.bind(this);
        this.addNumber = this.addNumber.bind(this);
        this.delNumber = this.delNumber.bind(this);

        this.ajaxTestSend = this.ajaxTestSend.bind(this);

        this.state = {
            loading: false,
            inputNumber: '',
            testSendArray: [],
        }
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.state.inputNumber !== nextState.inputNumber
            || this.state.testSendArray !== nextState.testSendArray
            || this.props.isOpen !== nextProps.isOpen
        )
    }

    setValue(id, value) {
        switch(id) {
            case "inputNumber":
                this.setState({ inputNumber: stringUtil.pureNumber(value) });
                break;
        }
    }

    addNumber() {
        const { inputNumber, testSendArray } = this.state;

        if (! inputNumber) {
            alert("테스트 발송할 전화번호가 입력되지 않았습니다.");
            return;
        }

        if (! stringUtil.formatPhone(inputNumber)) {
            alert("올바른 전화번호 형식이 아닙니다.");
            return;
        }

        if (testSendArray.length === 20) {
            alert("전화번호는 최대 20개까지 추가할 수 있습니다.");
            return;
        }

        let duplicatedValues = testSendArray.filter((item) => item === inputNumber);
        if (duplicatedValues.length > 0) {
            alert("이미 추가된 전화번호입니다.");
            return;
        }

        this.setState({
            testSendArray: testSendArray.concat(inputNumber),
            inputNumber: '',
        });
    }

    delNumber(phoneNumber) {
        const { testSendArray } = this.state;
        this.setState({ testSendArray: testSendArray.filter((item) => item !== phoneNumber) })
    }

    ajaxTestSend() {
        const { cmpnUid, onClose } = this.props;
        const { testSendArray } = this.state;

        if (! window.confirm("테스트 발송을 진행하시겠습니까?")) {
            return;
        }

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/test/send/" + cmpnUid,
            method: apiUtil.requestMethod.POST,
            data: {
                phoneNumber: testSendArray,
            },
            success: (result) => {
                alert("테스트 전송 요청 완료되었습니다.");
                onClose();
            }
        })
    }

    render () {
        const { loading } = this.state;
        const { isOpen, onClose } = this.props;

        const { inputNumber, testSendArray } = this.state;
        const { setValue, addNumber, delNumber, ajaxTestSend } = this;

        return (
            <Modal open={isOpen} handleClose={onClose} modalTitle={"테스트 발송"} className={'react-modal'}>
                <Loading loading={loading}/>
                <div className={"modal-body"}>
                    <h5>전화번호 추가</h5>
                    <div className='d-flex'>
                        <TextInput
                            className="form-control w-auto"
                            type="text"
                            id="inputNumber"
                            value={inputNumber}
                            onChange={setValue}
                            placeholder="전화번호 입력해주세요"
                        />
                        <span onClick={addNumber} class="material-symbols-rounded text-primary pointer fs-2 cursor-point">add_box</span>
                    </div>
                    
                    <ul className='list-unstyled ps-0 pb-0 fs-6 mb-0'>
                        <li>* 테스트 발송은 SKT 회선 사용자에 한해서만 발송이 가능합니다.</li>
                        <li>* 테스트 발송은 최대 20번까지 가능합니다.</li>
                        <li>* 해당 발송을 테스트 외 용도로 사용할 경우 서비스 이용이 제한이 있을 수 있습니다.</li>
                    </ul>

                    <hr/>
                    <table className={"table table-bordered text-center"}>
                        <thead className='table-primary border'>
                        <tr>
                            <th>NO</th>
                            <th>전화번호</th>
                            <th>삭제</th>
                        </tr>
                        </thead>
                        <tbody>
                        {testSendArray.length > 0 ? testSendArray.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{stringUtil.formatPhone(item)}</td>
                                    <td><button className='btn btn-primary p-1 d-flex align-items-center mx-auto' onClick={() => delNumber(item)}><span class="material-symbols-rounded fs-5">remove</span></button></td>
                                </tr>
                            )
                        })
                        :
                            <tr><td colSpan={3}>추가된 전화번호가 없습니다</td></tr>
                        }
                        </tbody>
                    </table>
                </div>
                <div className={"modal-footer"}>
                    <button className='btn btn-primary btn-md me-2' onClick={ajaxTestSend}>발송</button>
                    <button className='btn btn-secondary btn-md' onClick={onClose}>취소</button>
                </div>

            </Modal>
        );
    }
}


export default MessageTestModal;
